<template>
  <div>
    <router-link :to="{path:'/admincreditlist'}"  class="sidebar-nav-link" >
      <span><el-button  style="margin-left: 40%" type="primary" @click="autSearch" size="medium">公示业务数据查询</el-button></span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'admincreditlistbtn'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/admincreditlistbtn.vue